import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../../../shared/components/layout/Layout';

const CookiesPolicyPage = () => {
    const { t } = useTranslation();

    return (
        <Layout title={t('legal.cookies.title')} showAuthLinks={false}>
            <div className="max-w-3xl mx-auto space-y-8 text-gray-700">
                <p className="text-sm text-gray-500">
                    {t('legal.cookies.lastUpdated', { date: new Date() })}
                </p>

                <section className="space-y-4">
                    <h2 className="text-xl font-bold text-gray-900">{t('legal.cookies.sections.intro.title')}</h2>
                    <p>{t('legal.cookies.sections.intro.body')}</p>
                </section>

                <section className="space-y-4">
                    <h2 className="text-xl font-bold text-gray-900">{t('legal.cookies.sections.what.title')}</h2>
                    <p>{t('legal.cookies.sections.what.body')}</p>
                </section>

                <section className="space-y-4">
                    <h2 className="text-xl font-bold text-gray-900">{t('legal.cookies.sections.types.title')}</h2>
                    <div className="space-y-3">
                        <div>
                            <h3 className="font-semibold text-gray-900">{t('legal.cookies.sections.types.necessary.title')}</h3>
                            <p className="text-gray-700">{t('legal.cookies.sections.types.necessary.body')}</p>
                        </div>
                        <div>
                            <h3 className="font-semibold text-gray-900">{t('legal.cookies.sections.types.analytics.title')}</h3>
                            <p className="text-gray-700">{t('legal.cookies.sections.types.analytics.body')}</p>
                        </div>
                        <div>
                            <h3 className="font-semibold text-gray-900">{t('legal.cookies.sections.types.marketing.title')}</h3>
                            <p className="text-gray-700">{t('legal.cookies.sections.types.marketing.body')}</p>
                        </div>
                    </div>
                </section>

                <section className="space-y-4">
                    <h2 className="text-xl font-bold text-gray-900">{t('legal.cookies.sections.specific.title')}</h2>
                    <div className="space-y-4">
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <h3 className="font-semibold text-gray-900 mb-2">{t('legal.cookies.sections.specific.googleAnalytics.title')}</h3>
                            <p className="text-sm text-gray-700 mb-2">{t('legal.cookies.sections.specific.googleAnalytics.description')}</p>
                            <ul className="list-disc pl-6 text-sm text-gray-600 space-y-1">
                                <li>{t('legal.cookies.sections.specific.googleAnalytics.purpose')}</li>
                                <li>{t('legal.cookies.sections.specific.googleAnalytics.provider')}</li>
                                <li>{t('legal.cookies.sections.specific.googleAnalytics.duration')}</li>
                                <li>{t('legal.cookies.sections.specific.googleAnalytics.type')}</li>
                            </ul>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <h3 className="font-semibold text-gray-900 mb-2">{t('legal.cookies.sections.specific.facebookPixel.title')}</h3>
                            <p className="text-sm text-gray-700 mb-2">{t('legal.cookies.sections.specific.facebookPixel.description')}</p>
                            <ul className="list-disc pl-6 text-sm text-gray-600 space-y-1">
                                <li>{t('legal.cookies.sections.specific.facebookPixel.purpose')}</li>
                                <li>{t('legal.cookies.sections.specific.facebookPixel.provider')}</li>
                                <li>{t('legal.cookies.sections.specific.facebookPixel.duration')}</li>
                                <li>{t('legal.cookies.sections.specific.facebookPixel.type')}</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section className="space-y-4">
                    <h2 className="text-xl font-bold text-gray-900">{t('legal.cookies.sections.manage.title')}</h2>
                    <p>{t('legal.cookies.sections.manage.body')}</p>
                </section>

                <section className="space-y-4">
                    <h2 className="text-xl font-bold text-gray-900">{t('legal.cookies.sections.disable.title')}</h2>
                    <p className="mb-3">{t('legal.cookies.sections.disable.body')}</p>
                    <ul className="list-disc pl-6 space-y-1 text-sm">
                        <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800">Chrome</a></li>
                        <li><a href="https://support.mozilla.org/es/kb/impedir-que-los-sitios-web-guarden-sus-preferencia" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800">Firefox</a></li>
                        <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800">Safari</a></li>
                        <li><a href="https://support.microsoft.com/es-es/windows/eliminar-y-administrar-cookies" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800">Edge</a></li>
                    </ul>
                </section>

                <section className="space-y-4">
                    <h2 className="text-xl font-bold text-gray-900">{t('legal.cookies.sections.responsible.title')}</h2>
                    <div className="bg-gray-50 p-4 rounded-lg text-sm">
                        <p><strong>{t('legal.cookies.sections.responsible.name')}</strong> Albert Ramos Pastor</p>
                        <p><strong>{t('legal.cookies.sections.responsible.nif')}</strong> 47977582L</p>
                        <p><strong>{t('legal.cookies.sections.responsible.address')}</strong> C/ Lepant 270</p>
                        <p><strong>{t('legal.cookies.sections.responsible.email')}</strong> hola@heaful.app</p>
                    </div>
                </section>
            </div>
        </Layout>
    );
};

export default CookiesPolicyPage;


